import React from "react";

export interface RenderWhenProps {
    /** Условие рендера: при `true` отображается `children`. */
    when: boolean;
    /** Запасной контент, который рендерится при `when === false`. */
    fallback?: React.ReactNode;
    /** Основной контент, который рендерится при `when === true`. */
    children: React.ReactNode;
}

/**
 * Универсальный helper для условного рендера.
 * Возвращает `children`, когда `when === true`, иначе `fallback` (или `null`).
 */
export const RenderWhen: React.FC<RenderWhenProps> = ({ when, fallback = null, children }) => {
    if (!when) return <>{fallback}</>;
    return <>{children}</>;
};
